var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogophoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2560.265,
    height: 542.573,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-863.366-622.247h2231.853v864.656H-863.366z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-131.769 76.976v66.564l49.475 28.082 13.723 7.817-6.136 14.517-52.408 124.163L.238 392.982l131.601-77.024v-.15L.296 239.339l58.278-138.527L.107 66.674.034.017 0 0Zm149.571 326.117L.224 413.516-149.5 325.537l58.47-138.468-58.47-33.219V66.808L.009-20.542l149.027 87.216-57.26 139.575 57.795 33.381v86.487z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 286.875 516.895)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-897.219-22.652c-6.978-2.479-13.012-4.48-21.492-4.48-21.979 0-26.826 7.275-26.843 37.309.017 30.027 4.864 37.302 26.843 37.302 8.48 0 14.514-2.125 21.492-4.613v29.165c-5.969 1.909-13.356 3.78-20.381 3.78-47.33 0-61.447-12.136-61.447-65.634 0-53.497 13.212-65.638 56.191-65.638 12.85 0 23.665 3.281 32.489 6.846zm-99.77 0c-6.984-2.479-13.013-4.48-21.504-4.48-21.978 0-26.82 7.275-26.839 37.309.02 30.027 4.861 37.302 26.839 37.302 8.491 0 14.52-2.125 21.504-4.613v29.165c-5.965 1.909-13.354 3.78-20.385 3.78-47.337 0-61.453-12.136-61.453-65.634 0-53.497 13.218-65.638 56.205-65.638 12.836 0 23.65 3.281 32.481 6.846zm272.148 38.036h-11.956v32.095h10.933c16.056 0 17.229-6.47 17.229-15.668 0-8.543.342-16.427-16.206-16.427m29.218-19.11c12.924 3.242 17.607 22.36 17.607 36.74 0 35.467-13.998 41.162-48.729 41.162h-42.258V-54.617h32.206v46.731h12.994l16.682-46.73h33.186s-10.828 24.486-21.688 50.89m-403.217-50.751h-77.409V74.176h77.409V47.479h-45.127v-23.67l38.769.04V.148h-38.77V-27.23h45.128v-27.248zm305.521 0H-870.7V74.176h77.382V47.479h-45.124v-23.67l38.758.04V.148h-38.758V-27.23h45.124v-27.248zm-403.277.015h-91.06l44.034 101.942h-42.96v26.695h88.228l-43.56-100.944h45.318z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 2284.398 287.02)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 1740.061,
    y: 356.529,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "226.667px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      fill: "#fff"
    },
    transform: "translate(0 3.423)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1740.061,
    y: 356.529,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "226.667px",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot"
    }
  }, "PHOTO"))), /*#__PURE__*/React.createElement("path", {
    d: "M1594.104 52.237h13.087v438.099h-13.087z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogophoto);
export default __webpack_public_path__ + "static/media/logo.photo.9f9745ae6b089d8b9e950c0192b58cb1.svg";
export { ForwardRef as ReactComponent };